import { render, staticRenderFns } from "./adminSchool.vue?vue&type=template&id=61971619&scoped=true"
import script from "./adminSchool.vue?vue&type=script&lang=js"
export * from "./adminSchool.vue?vue&type=script&lang=js"
import style0 from "./adminSchool.vue?vue&type=style&index=0&id=61971619&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61971619",
  null
  
)

export default component.exports